import { createContext, useContext, type Provider } from "react";
import type { AddressFieldsApi } from "./address-fields-api";

const AddressFieldsApiContext = createContext<AddressFieldsApi | null>(null);

export const AddressFieldsApiProvider: Provider<AddressFieldsApi | null> =
  AddressFieldsApiContext.Provider;

export function useAddressFieldsApi(): AddressFieldsApi {
  const api = useContext(AddressFieldsApiContext);
  if (!api) {
    throw new Error(
      "useAddressFieldsApi must be used within an AddressFieldsApiProvider",
    );
  }
  return api;
}

export function useAddressFieldsApiOptional(): AddressFieldsApi | null {
  return useContext(AddressFieldsApiContext);
}
